import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';
import { Customer, CreateCustomer, UpdateCustomer } from '../types/customer';

export const customerApi = createApi({
  reducerPath: 'customerApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Customer'],
  endpoints: (builder) => ({
    getCustomers: builder.query<Customer[], void>({
      query: () => 'customers',
      providesTags: ['Customer'],
    }),
    getTopCustomers: builder.query<Customer[], void>({
      query: () => 'customers/top',
    }),
    createCustomer: builder.mutation<Customer, CreateCustomer>({
      query: (body) => ({ url: 'customers', method: 'POST', body }),
      invalidatesTags: ['Customer'],
    }),
    updateCustomer: builder.mutation<Customer, { id: string; data: UpdateCustomer }>({
      query: ({ id, data }) => ({ url: `customers/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['Customer'],
    }),
    deleteCustomer: builder.mutation<void, string>({
      query: (id) => ({ url: `customers/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Customer'],
    }),
  }),
});

export const {
  useGetCustomersQuery,
  useGetTopCustomersQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation,
} = customerApi;
